module.exports = __webpack_public_path__ + "static/media/WEB7.c2a4a8c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB7.png
// module id = 83
// module chunks = 0